import User from 'models/User'
import apiService from 'services/api.service'
import store from 'store'

export default {

    async activate (login, token) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'user/activatePhys',
                method: 'get',
                params: {
                    token: token,
                    login: login
                },
                locale: lang
            }, true).then(response => {
                resolve(response.data.data)
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async login (credentials) {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'login',
                method: 'post',
                params: credentials
            }, true).then(response => {
                if (response.data.data){
                    const curUser = new User(response.data.data)
                    if (curUser.isAuthUser()) {
                        resolve(curUser)
                    }
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async logout () {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'logout'
            }).then(() => {
                resolve('logout_success')
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getUserBySession () {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'getuser'
            }).then(response => {
                if (response.data.data){
                    const curUser = new User(response.data.data)
                    if (curUser.isAuthUser()) {
                        resolve(curUser)
                    } else {
                        reject('no_user_found')
                    }
                } else {
                    reject('no_user_found')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getUserByToken (token) {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'getuser',
                token: token
            }).then(response => {
                if (response.data.data){
                    const curUser = new User(response.data.data)
                    if (curUser.isAuthUser()) {
                        resolve(curUser)
                    } else {
                        reject('no_user_found')
                    }
                } else {
                    reject('no_user_found')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async register(formData) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'user/registrationPhys',
                method: 'get',
                params: formData,
                locale: lang
            }, true).then(response => {
                if (response.data.success) {
                    resolve(response.data);
                } else {
                    reject('Signup failed!');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },

    async restorePassword(email) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'user/recoverpasswordPhys',
                method: 'get',
                params: { login: email },
                locale: lang
            }).then(response => {
                if (response.data.success) {
                    resolve(response.data);
                } else {
                    reject('Password recovery failed!');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }


}
